import EffortlessLoginModal from './effortless-login-modal';

export default EffortlessLoginModal;
